import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const SimpleCircleBase = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${theme.largerThan.lg} {
    max-width: 400px;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Image = styled.img`
  border-radius: 50%;
  width: 78px !important;
`;

export const Title = styled.h3``;

export const Description = styled.div`
  font-size: ${theme.fontSizes[2]};
`;
